import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useFormik } from 'formik';

import { loginAction } from '../state/auth/actions';

import InputField from '../components/inputField';
import Button from '../components/button';

import quizData from '../../content/quiz.json';

function validateSchoolCode({ schoolCode }, errors) {
  if (!schoolCode) {
    return { schoolCode: quizData.form.fields.schoolCode.required };
  }
  if (typeof schoolCode !== 'string') {
    return { schoolCode: quizData.form.fields.schoolCode.format };
  }
  if (!quizData.schools.includes(schoolCode.trim())) {
    return { schoolCode: quizData.form.fields.schoolCode.format };
  }
}

function validateClassNumber({ classNumber }) {
  if (!classNumber) {
    return { classNumber: quizData.form.fields.classNumber.required };
  }
  if (typeof classNumber !== 'string') {
    return { classNumber: quizData.form.fields.classNumber.format };
  }
  if (!quizData.classes.includes(classNumber.trim())) {
    return { classNumber: quizData.form.fields.classNumber.format };
  }
}

function validate(values, props) {
  return Object.assign({}, validateSchoolCode(values), validateClassNumber(values));
}

const LoginForm = ({ schoolCodeInitial, classNumberInitial, error, loginAction, translation }) => {
  const [isInSKO, setIsInSKO] = useState(null);
  const [selectedClass, setSelectedClass] = useState(0);

  const formik = useFormik({
    initialValues: {
      schoolCode: schoolCodeInitial || '',
      classNumber: classNumberInitial || '0',
    },
    validate,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: values => {
      loginAction({ ...values });
    },
  });

  return (
    <div className="login-form">
      <div className="login-form__title" dangerouslySetInnerHTML={{ __html: translation.title }} />
      <div className="login-form__description">{translation.description}</div>
      <form onSubmit={formik.handleSubmit}>
        <label className="input-field__label">{quizData.form.isInSKO.label}</label>
        <div className="login-form__btns">
          <Button type="button" className={isInSKO === true && 'active'} onClick={() => setIsInSKO(true)}>
            {quizData.form.isInSKO.yes}
          </Button>
          <Button type="button" className={isInSKO === false && 'active'} onClick={() => setIsInSKO(false)}>
            {quizData.form.isInSKO.no}
          </Button>
        </div>

        {isInSKO !== null && (
          <InputField
            {...quizData.form.fields.schoolCode}
            name="schoolCode"
            maxLength="4"
            error={formik.errors.schoolCode}
            touched={formik.touched.schoolCode}
            onChange={formik.handleChange}
            label={isInSKO ? quizData.form.fields.schoolCodeCondition.yes : quizData.form.fields.schoolCodeCondition.no}
            value={formik.values.schoolCode}
          />
        )}

        <label className="input-field__label">{quizData.form.fields.classNumberGroup.label}</label>
        <div className="login-form__btns">
          <Button
            className={selectedClass === 0 && 'active'}
            type="button"
            onClick={() => {
              setSelectedClass(0);
              formik.setFieldValue('classNumber', '0');
            }}
          >
            Klasa 0-2
          </Button>
          <Button
            className={selectedClass === 3 && 'active'}
            type="button"
            onClick={() => {
              setSelectedClass(3);
              formik.setFieldValue('classNumber', '3');
            }}
          >
            Klasa 3-4
          </Button>
          <Button
            className={selectedClass === 5 && 'active'}
            type="button"
            onClick={() => {
              setSelectedClass(5);
              formik.setFieldValue('classNumber', '5');
            }}
          >
            Klasa 5-6
          </Button>
          <Button
            className={selectedClass === 7 && 'active'}
            type="button"
            onClick={() => {
              setSelectedClass(7);
              formik.setFieldValue('classNumber', '7');
            }}
          >
            Klasa 7-8
          </Button>
        </div>

        <div style={{ display: 'none' }}>
          <InputField
            {...translation.fields.classNumber}
            name="classNumber"
            maxLength="1"
            error={formik.errors.classNumber}
            touched={formik.touched.classNumber}
            onChange={formik.handleChange}
            value={formik.values.classNumber || '0'}
          />
        </div>

        <p className="input-field__label login-form__last-description" dangerouslySetInnerHTML={{ __html: quizData.form.finalDescription }} />

        <Button type="submit">{translation.button}</Button>
      </form>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    isLoading: state.root.auth.isLoading,
    schoolCodeInitial: state.root.auth.schoolCode,
    classNumberInitial: state.root.auth.classNumber,
    error: state.root.auth.error,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loginAction: values => dispatch(loginAction(values)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
